import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMsqlServer,
  DiMysql,
  DiPostgresql,
  DiJava
} from "react-icons/di";
import {
  SiSpringboot,
  SiAngular,
  SiAmazonaws,
  SiGooglecloud,
  SiRedhatopenshift,
  SiPython
} from "react-icons/si";
import apacheCamelIcon from "../../Assets/apach-camel.svg";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {/* Programming Languages */}
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <DiJava />
        <div style={{fontSize: "12px", marginTop: "5px"}}>Java</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <DiJavascript1 />
        <div style={{fontSize: "12px", marginTop: "5px"}}>JavaScript</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <SiPython />
        <div style={{fontSize: "12px", marginTop: "5px"}}>Python</div>
      </Col>
      
      {/* Frameworks */}
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <SiSpringboot />
        <div style={{fontSize: "12px", marginTop: "5px"}}>Spring Boot</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <div 
          style={{
            width: "65px", 
            height: "65px",
            background: `url(${apacheCamelIcon}) no-repeat center center`,
            backgroundSize: "contain",
            filter: "grayscale(100%) brightness(100%) contrast(100%)",
            mixBlendMode: "multiply",
            margin: "30px auto 0 auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }} 
        />
        <div style={{fontSize: "12px", marginTop: "5px"}}>Apache Camel</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <DiReact />
        <div style={{fontSize: "12px", marginTop: "5px"}}>React</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <SiAngular />
        <div style={{fontSize: "12px", marginTop: "5px"}}>Angular</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <DiNodejs />
        <div style={{fontSize: "12px", marginTop: "5px"}}>Node.js</div>
      </Col>
      
      {/* Cloud Platforms */}
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <SiAmazonaws />
        <div style={{fontSize: "12px", marginTop: "5px"}}>AWS</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <SiGooglecloud />
        <div style={{fontSize: "12px", marginTop: "5px"}}>GCP</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <SiRedhatopenshift />
        <div style={{fontSize: "12px", marginTop: "5px"}}>OpenShift</div>
      </Col>
      
      {/* Databases */}
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <DiPostgresql />
        <div style={{fontSize: "12px", marginTop: "5px"}}>PostgreSQL</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <DiMsqlServer />
        <div style={{fontSize: "12px", marginTop: "5px"}}>SQL Server</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons" style={{textAlign: "center"}}>
        <DiMysql />
        <div style={{fontSize: "12px", marginTop: "5px"}}>MySQL</div>
      </Col>
    </Row>
  );
}

export default Techstack;
